var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import Nav from "./partials/Nav";
// Patch pushState so any navigation (React Router <Link>, NavLink, etc.) fires popstate.
// SideNav and other listeners use popstate to track the current URL.
var _pushState = window.history.pushState.bind(window.history);
window.history.pushState = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    _pushState.apply(void 0, args);
    window.dispatchEvent(new PopStateEvent("popstate"));
};
// import Authentication from "./views/authentication";
var Authentication = React.lazy(function () {
    return import("./views/authentication" /* webpackChunkName: "authentication" */);
});
var Library = React.lazy(function () { return import("./views/library" /* webpackChunkName: "library" */); });
var NewPage = React.lazy(function () { return import("./views/new-page" /* webpackChunkName: "new-page" */); });
var Profile = React.lazy(function () { return import("./views/profile" /* webpackChunkName: "profile" */); });
var PublicProfile = React.lazy(function () {
    return import("./views/public-profile" /* webpackChunkName: "public-profile" */);
});
var EditPage = React.lazy(function () { return import("./views/edit-page/EditPage" /* webpackChunkName: "edit-page" */); });
// // import Actions from "./views/show-page/Actions";
// // import Photo from "./views/show-page/Photo";
// // import AttachFiles from "./views/show-page/AttachFiles";
// // import Author from "./views/show-page/Author";
// // import Ratings from "./views/show-page/Ratings";
// // import Comments from "./views/show-page/Comments";
// // import ShowPrivate from "./views/show-page/Private";
import { store as showPageStore } from "./views/show-page/store";
var navRoot = document.getElementById("nav-root");
if (navRoot)
    ReactDOM.createRoot(navRoot).render(_jsx(Nav, {}));
var container = document.querySelector(".react-container");
var containerName = container ? container.getAttribute("name") : null;
if (containerName === "authentication") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var authenticationRoot;
        return __generator(this, function (_a) {
            authenticationRoot = ReactDOM.createRoot(container);
            authenticationRoot.render(_jsx(React.Suspense, __assign({ fallback: _jsx("div", {}) }, { children: _jsx(React.StrictMode, { children: _jsx(Authentication, {}) }) })));
            return [2 /*return*/];
        });
    }); })();
}
// ---------- SHOW PUBLIC  ----------- //
if (containerName === "show-public") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var Actions, Photo, AttachFiles, Author, Ratings, Comments, actionsRoot, photoRoot, attachFilesRoot, authorRoot, ratingRoot, commentsRoot;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import("./views/show-page/Actions" /* webpackChunkName: "actions" */)];
                case 1:
                    Actions = (_a.sent()).default;
                    return [4 /*yield*/, import("./views/show-page/Photo" /* webpackChunkName: "photo" */)];
                case 2:
                    Photo = (_a.sent()).default;
                    return [4 /*yield*/, import("./views/show-page/AttachFiles" /* webpackChunkName: "attach-files" */)];
                case 3:
                    AttachFiles = (_a.sent()).default;
                    return [4 /*yield*/, import("./views/show-page/Author" /* webpackChunkName: "author" */)];
                case 4:
                    Author = (_a.sent()).default;
                    return [4 /*yield*/, import("./views/show-page/Ratings" /* webpackChunkName: "ratings" */)];
                case 5:
                    Ratings = (_a.sent()).default;
                    return [4 /*yield*/, import("./views/show-page/Comments" /* webpackChunkName: "comments" */)];
                case 6:
                    Comments = (_a.sent()).default;
                    actionsRoot = ReactDOM.createRoot(document.querySelector("#actions"));
                    actionsRoot.render(_jsx(Provider, __assign({ store: showPageStore }, { children: _jsx(Actions, { type: "public" }) })));
                    photoRoot = ReactDOM.createRoot(document.querySelector("#photo"));
                    photoRoot.render(_jsx(Provider, __assign({ store: showPageStore }, { children: _jsx(Photo, {}) })));
                    attachFilesRoot = ReactDOM.createRoot(document.querySelector("#attach-files"));
                    attachFilesRoot.render(_jsx(Provider, __assign({ store: showPageStore }, { children: _jsx(AttachFiles, {}) })));
                    if (document.querySelector("#author")) {
                        authorRoot = ReactDOM.createRoot(document.querySelector("#author"));
                        authorRoot.render(_jsx(Provider, __assign({ store: showPageStore }, { children: _jsx(Author, {}) })));
                    }
                    if (document.querySelector("#rating")) {
                        ratingRoot = ReactDOM.createRoot(document.querySelector("#rating"));
                        ratingRoot.render(_jsx(Provider, __assign({ store: showPageStore }, { children: _jsx(Ratings, {}) })));
                    }
                    if (document.querySelector("#comments")) {
                        commentsRoot = ReactDOM.createRoot(document.querySelector("#comments"));
                        commentsRoot.render(_jsx(Provider, __assign({ store: showPageStore }, { children: _jsx(Comments, {}) })));
                    }
                    return [2 /*return*/];
            }
        });
    }); })();
}
// ---------- END SHOW PUBLIC  ----------- //
if (containerName === "show-private") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var ShowPrivate, showPrivateRoot;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import("./views/show-page/Private" /* webpackChunkName: "show-private" */)];
                case 1:
                    ShowPrivate = (_a.sent()).default;
                    showPrivateRoot = ReactDOM.createRoot(container);
                    showPrivateRoot.render(_jsx(Provider, __assign({ store: showPageStore }, { children: _jsx(ShowPrivate, {}) })));
                    return [2 /*return*/];
            }
        });
    }); })();
}
if (containerName === "main") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var authenticationRoot;
        return __generator(this, function (_a) {
            authenticationRoot = ReactDOM.createRoot(container);
            authenticationRoot.render(_jsx(React.Suspense, __assign({ fallback: _jsx("div", {}) }, { children: _jsx(React.StrictMode, { children: _jsx(Library, {}) }) })));
            return [2 /*return*/];
        });
    }); })();
}
if (containerName === "new-page") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var authenticationRoot;
        return __generator(this, function (_a) {
            authenticationRoot = ReactDOM.createRoot(container);
            authenticationRoot.render(_jsx(React.Suspense, __assign({ fallback: _jsx("div", {}) }, { children: _jsx(NewPage, {}) })));
            return [2 /*return*/];
        });
    }); })();
}
if (containerName === "profile") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var authenticationRoot;
        return __generator(this, function (_a) {
            authenticationRoot = ReactDOM.createRoot(container);
            authenticationRoot.render(_jsx(React.Suspense, __assign({ fallback: _jsx("div", {}) }, { children: _jsx(React.StrictMode, { children: _jsx(Profile, {}) }) })));
            return [2 /*return*/];
        });
    }); })();
}
if (containerName === "public-profile") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var authenticationRoot;
        return __generator(this, function (_a) {
            authenticationRoot = ReactDOM.createRoot(container);
            authenticationRoot.render(_jsx(React.Suspense, __assign({ fallback: _jsx("div", {}) }, { children: _jsx(React.StrictMode, { children: _jsx(PublicProfile, {}) }) })));
            return [2 /*return*/];
        });
    }); })();
}
if (containerName === "edit-page") {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var editPageRoot;
        return __generator(this, function (_a) {
            editPageRoot = ReactDOM.createRoot(container);
            editPageRoot.render(_jsx(React.Suspense, __assign({ fallback: _jsx("div", {}) }, { children: _jsx(EditPage, {}) })));
            return [2 /*return*/];
        });
    }); })();
}
